import { render, staticRenderFns } from "./zhaobiaoxq.vue?vue&type=template&id=ab207d12&scoped=true&"
import script from "./zhaobiaoxq.vue?vue&type=script&lang=js&"
export * from "./zhaobiaoxq.vue?vue&type=script&lang=js&"
import style0 from "./zhaobiaoxq.vue?vue&type=style&index=0&id=ab207d12&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab207d12",
  null
  
)

export default component.exports